module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "recruit22.3c9b7f59.png";